"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpStudentsStandardsDetails = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var react_i18next_1 = require("react-i18next");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var flatten_1 = __importDefault(require("lodash/flatten"));
var uniqWith_1 = __importDefault(require("lodash/uniqWith"));
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var api_1 = require("../../../api");
var DpStudentsStandardsDetails_styled_1 = require("./DpStudentsStandardsDetails.styled");
var DpDetailedPerformanceTable_1 = __importDefault(require("../DetailedPerformanceTable/DpDetailedPerformanceTable"));
var DpSectionCard_1 = __importDefault(require("../Cards/DpSectionCard"));
var DpStandardModal_1 = __importDefault(require("../StandardModal/DpStandardModal"));
var DpStudentDetailModal_1 = __importDefault(require("../StudentDetailModal/DpStudentDetailModal"));
var Assessment_1 = require("../../Assessment");
var themeBands = (_a = {},
    _a[api_1.Bands.NotProficient] = 'notYet',
    _a[api_1.Bands.PartiallyProficient] = 'partial',
    _a[api_1.Bands.HighlyProficient] = 'highlyProficient',
    _a[api_1.Bands.Proficient] = 'proficient',
    _a);
var DpStudentsStandardsDetails = function (_a) {
    // --------------------------- Context
    var assigneesPerformance = _a.assigneesPerformance, classPerformance = _a.classPerformance, assessments = _a.assessments, templates = _a.templates, activeClass = _a.activeClass, standardType = _a.standardType;
    var themeContext = (0, react_1.useContext)(styled_components_1.ThemeContext);
    var t = (0, react_i18next_1.useTranslation)('common').t;
    // --------------------------- State
    var _b = (0, react_1.useState)(false), initialized = _b[0], setInitialized = _b[1];
    var _c = (0, react_1.useState)([]), formattedData = _c[0], setFormattedData = _c[1];
    var _d = (0, react_1.useState)([]), headerData = _d[0], setHeaderData = _d[1];
    var _e = (0, react_1.useState)(false), showStandardModal = _e[0], setShowStandardModal = _e[1];
    var _f = (0, react_1.useState)(false), showStudentDetailModal = _f[0], setShowStudentDetailModal = _f[1];
    var _g = (0, react_1.useState)(null), activeStandard = _g[0], setActiveStandard = _g[1];
    var _h = (0, react_1.useState)(null), activeStudent = _h[0], setActiveStudent = _h[1];
    var getPrintableTable = (0, react_1.useMemo)(function () {
        var _a;
        var printableObjects = [];
        var _loop_1 = function (index) {
            var lastElementIndex = index === 0 ? index + 6 : index + 7;
            var tableChunk = formattedData.map(function (data) {
                var dataClone = (0, cloneDeep_1.default)(data);
                dataClone.performances = data.performances.slice(index, lastElementIndex);
                return dataClone;
            });
            var table = ((0, jsx_runtime_1.jsx)(DpDetailedPerformanceTable_1.default, { data: tableChunk, headers: headerData.slice(index, lastElementIndex), classId: classPerformance.classes[0].id, columnsToShow: 7 }));
            printableObjects.push(table);
            index === 0 ? (index += 6) : (index += 7);
            out_index_1 = index;
        };
        var out_index_1;
        for (var index = 0; index < ((_a = formattedData[0]) === null || _a === void 0 ? void 0 : _a.performances.length);) {
            _loop_1(index);
            index = out_index_1;
        }
        return printableObjects;
    }, [classPerformance, formattedData, headerData]);
    var bandLabelColor = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = {},
            _a[api_1.Bands.NotProficient] = themeContext.Colors.dark,
            _a[api_1.Bands.PartiallyProficient] = themeContext.Colors.dark,
            _a[api_1.Bands.HighlyProficient] = themeContext.Colors.white,
            _a[api_1.Bands.Proficient] = themeContext.Colors.dark,
            _a);
    }, [themeContext]);
    var standardHeaders = (0, react_1.useMemo)(function () {
        var allStandardPerformances = (assigneesPerformance || []).map(function (_a) {
            var standardsPerformance = _a.standardsPerformance;
            return standardsPerformance;
        });
        return (0, uniqWith_1.default)((0, flatten_1.default)(allStandardPerformances), function (a, b) { return a.standard === b.standard; }).map(function (_a) {
            var standard = _a.standard;
            return standard;
        });
    }, [assigneesPerformance]);
    // --------------------------------- Actions
    var openStandard = function (standard) { return function () {
        setActiveStandard(standard);
        setShowStandardModal(true);
    }; };
    var closeStandardModal = function () {
        setActiveStandard(null);
        setShowStandardModal(false);
    };
    var closeStudentDetailModal = function () {
        setShowStudentDetailModal(false);
        setActiveStudent(null);
        setActiveStandard(null);
    };
    var openStudentDetailModal = function (assigneeId, standard) {
        var student = assigneesPerformance.find(function (_a) {
            var assignee = _a.assignee;
            return assignee.id === assigneeId;
        });
        setActiveStudent(student === null || student === void 0 ? void 0 : student.assignee);
        setActiveStandard(standard);
        setShowStudentDetailModal(true);
    };
    // --------------------------- Methods
    var parseHeaderData = (0, react_1.useCallback)(function () {
        return standardHeaders.map(function (item, index) { return ((0, jsx_runtime_1.jsx)("div", { role: "button", tabIndex: 0, className: "column-header clickable", onClick: openStandard(item), onKeyDown: (0, api_1.handleButtonPress)(openStandard(item)), children: (0, jsx_runtime_1.jsx)(Assessment_1.DpTags, { tags: [(0, api_1.getShortCodeFromGlobalId)(item)], maxToShow: 1, variant: "icon" }) }, index + 1)); });
    }, [standardHeaders]);
    var parseOverallData = (0, react_1.useCallback)(function (classPerformanceData) { return ({
        id: 'overall',
        name: t('DpDetailedPerformanceTable.classAverage'),
        overall: {
            performance: classPerformanceData.overallPercentage,
            color: (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(classPerformanceData.overallPerformanceBand.curriculum), themeBands[classPerformanceData.overallPerformanceBand.code]),
            labelColor: themeContext.Colors.dark,
            bandLegend: t("generalConstants.bandLegend.".concat(themeBands[classPerformanceData.overallPerformanceBand.code])),
        },
        performances: standardHeaders.map(function (item) {
            var standardPerformance = classPerformanceData.standardsPerformance.find(function (_a) {
                var standard = _a.standard;
                return standard === item;
            });
            var curriculum = standardPerformance
                ? standardPerformance.band.curriculum
                : api_1.CurriculumId.EurekaMath;
            var bandCode = standardPerformance ? standardPerformance.band.code : api_1.Bands.NotProficient;
            return {
                standard: item,
                performance: (standardPerformance === null || standardPerformance === void 0 ? void 0 : standardPerformance.percentage) || 0,
                color: (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(curriculum), themeBands[bandCode]),
                labelColor: bandLabelColor[bandCode],
                bandLegend: t("generalConstants.bandLegend.".concat(themeBands[bandCode])),
                performanceAriaLabel: t('studentsStandardsDetails.performanceAriaLabel', {
                    standardLabel: (0, api_1.getShortCodeFromGlobalId)(item),
                    percentage: "".concat((0, api_1.formatPercentage)((standardPerformance === null || standardPerformance === void 0 ? void 0 : standardPerformance.percentage) || 0), "%"),
                    proficiency: t("generalConstants.bandLegend.".concat(themeBands[bandCode])),
                }),
            };
        }),
    }); }, [themeContext, bandLabelColor, t, standardHeaders]);
    var parseReportData = (0, react_1.useCallback)(function (reportData, assigneesPerformanceData) {
        assigneesPerformanceData.forEach(function (assigneePerformance) {
            var assignee = assigneePerformance.assignee;
            reportData.push({
                id: assignee.id,
                name: "".concat(assignee.lastName, ", ").concat(assignee.firstName),
                overall: {
                    performance: assigneePerformance.overallPercentage,
                    color: (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(assigneePerformance.overallPerformanceBand.curriculum), themeBands[assigneePerformance.overallPerformanceBand.code]),
                    labelColor: themeContext.Colors.dark,
                    bandLegend: t("generalConstants.bandLegend.".concat(themeBands[assigneePerformance.overallPerformanceBand.code])),
                },
                performances: standardHeaders.map(function (item) {
                    var standardPerformance = assigneePerformance.standardsPerformance.find(function (_a) {
                        var standard = _a.standard;
                        return standard === item;
                    });
                    var curriculum = standardPerformance
                        ? standardPerformance.band.curriculum
                        : api_1.CurriculumId.EurekaMath;
                    var bandCode = standardPerformance
                        ? standardPerformance.band.code
                        : api_1.Bands.NotProficient;
                    return {
                        standard: item,
                        performance: (standardPerformance === null || standardPerformance === void 0 ? void 0 : standardPerformance.percentage) || 0,
                        color: (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(curriculum), themeBands[bandCode]),
                        labelColor: bandLabelColor[bandCode],
                        bandLegend: t("generalConstants.bandLegend.".concat(themeBands[bandCode])),
                        performanceAriaLabel: t('reports.standardsReport.studentsDetails.performanceAriaLabel', {
                            standardLabel: (0, api_1.getShortCodeFromGlobalId)(item),
                            percentage: "".concat((0, api_1.formatPercentage)((standardPerformance === null || standardPerformance === void 0 ? void 0 : standardPerformance.percentage) || 0), "%"),
                            proficiency: t("generalConstants.bandLegend.".concat(themeBands[bandCode])),
                        }),
                    };
                }),
            });
        });
    }, [themeContext, bandLabelColor, standardHeaders, t]);
    var loadReportData = (0, react_1.useCallback)(function (assigneesPerformanceData, classPerformanceData) { return __awaiter(void 0, void 0, void 0, function () {
        var headers, overallData, reportData;
        return __generator(this, function (_a) {
            headers = parseHeaderData();
            setHeaderData(headers);
            overallData = parseOverallData(classPerformanceData);
            reportData = [overallData];
            parseReportData(reportData, assigneesPerformanceData);
            setFormattedData(reportData);
            setInitialized(true);
            return [2 /*return*/];
        });
    }); }, [parseHeaderData, parseReportData, parseOverallData]);
    (0, react_1.useEffect)(function () {
        if (!(0, isEmpty_1.default)(assigneesPerformance) && !(0, isEmpty_1.default)(classPerformance)) {
            loadReportData(assigneesPerformance, classPerformance);
        }
        else {
            setInitialized(false);
        }
    }, [assigneesPerformance, classPerformance, loadReportData]);
    return (initialized && ((0, jsx_runtime_1.jsx)(DpStudentsStandardsDetails_styled_1.StyledStudentsDetails, { className: "break-on-print student-details-wrapper", "data-testid": "student-details", children: (0, jsx_runtime_1.jsx)(DpSectionCard_1.default, { children: (0, jsx_runtime_1.jsxs)("div", { className: "report", children: [(0, jsx_runtime_1.jsx)("div", { className: "non-printable", children: (0, jsx_runtime_1.jsx)(DpDetailedPerformanceTable_1.default, { data: formattedData, headers: headerData, classId: classPerformance.classes[0].id, columnsToShow: 7, selectBadgeHandler: openStudentDetailModal }) }), (0, jsx_runtime_1.jsx)("div", { className: "printable", children: getPrintableTable }), showStandardModal && ((0, jsx_runtime_1.jsx)(DpStandardModal_1.default, { standardType: standardType, show: showStandardModal, closeHandler: closeStandardModal, standard: activeStandard })), showStudentDetailModal && ((0, jsx_runtime_1.jsx)(DpStudentDetailModal_1.default, { show: showStudentDetailModal, closeHandler: closeStudentDetailModal, aClass: activeClass, standard: activeStandard, student: activeStudent, assessments: assessments, templates: templates, standardHierarchyLevel: standardType }))] }) }) })));
};
exports.DpStudentsStandardsDetails = DpStudentsStandardsDetails;
exports.default = exports.DpStudentsStandardsDetails;
